exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".w-200[data-v-b9a2e9cc]{width:200px}.form-input[data-v-b9a2e9cc]{width:300px}", ""]);

// exports
